import { motion } from 'framer-motion';
import { UserCheck, Pencil, Check } from 'lucide-react';

function ReviewRow({ label, value, delay }) {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay }}>
      <p className="text-[12px] font-body font-bold text-[#0A0A0A]">{label}</p>
      <p className="text-[14px] font-body text-[#737373] mt-0.5">{value}</p>
    </motion.div>
  );
}

export default function NewUserConfirmProfileScene({ onNext }) {
  return (
    <div data-testid="scene-new-user-confirm-profile" className="flex flex-col items-center justify-start h-full px-8 pt-4 overflow-y-auto">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="w-full max-w-3xl">
        <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-6">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-body font-medium bg-teal-600/10 text-teal-700 mb-3">
            <UserCheck size={14} /> New User Flow
          </span>
          <h2 className="font-heading font-bold text-3xl md:text-4xl tracking-tight text-[#0A0A0A]">Confirm Details</h2>
          <p className="mt-2 font-body text-base text-[#737373]">Review and confirm your profile before proceeding</p>
        </motion.div>

        {/* Header with Edit */}
        <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }}
          className="flex items-center justify-between mb-5 pb-3 border-b border-[#E5E7EB]">
          <div>
            <h3 className="font-heading font-medium text-2xl text-[#0A0A0A]">Confirm Details</h3>
            <p className="font-body text-sm text-[#737373]">Take a moment to confirm your details before proceeding</p>
          </div>
          <button className="flex items-center gap-2 px-4 py-2 rounded-lg border border-[#E5E7EB] text-sm font-body text-[#0A0A0A] hover:bg-[#F5F5F5]">
            <Pencil size={14} /> Edit
          </button>
        </motion.div>

        {/* Basic details */}
        <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }}
          className="mb-6">
          <h4 className="font-heading font-bold text-lg text-[#0A0A0A] mb-4">Basic details</h4>
          <div className="grid grid-cols-2 gap-x-8 gap-y-4">
            <ReviewRow label="First name" value="Abdul" delay={0.4} />
            <ReviewRow label="Last name" value="Ahmed" delay={0.45} />
            <ReviewRow label="Business email address" value="abdulahmed@xyz.com" delay={0.5} />
            <ReviewRow label="Contact number" value="+971 - 501234567" delay={0.55} />
            <ReviewRow label="User type" value="Admin" delay={0.6} />
            <ReviewRow label="Nationality" value="UAE" delay={0.65} />
            <ReviewRow label="Emirates ID number" value="748-1234-1234567-1" delay={0.7} />
            <ReviewRow label="Linked facility" value="Star Insurers, Jumeirah" delay={0.75} />
          </div>
        </motion.div>

        {/* Assign roles */}
        <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.8 }}
          className="mb-6">
          <h4 className="font-heading font-bold text-lg text-[#0A0A0A] mb-1">Assign roles</h4>
          <p className="font-body text-sm text-[#737373] mb-4">Define what this user can access and manage</p>
          <div className="bg-[#FAFAFA] rounded-xl p-5 space-y-3">
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.9 }}>
              <p className="font-body font-bold text-sm text-[#0A0A0A]">Facility Admin</p>
              <p className="font-body text-[13px] text-[#737373]">Rashid Hospital Location A &bull; Rashid Hospital Location A</p>
            </motion.div>
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.0 }}>
              <p className="font-body font-bold text-sm text-[#0A0A0A]">Organisation Admin</p>
              <p className="font-body text-[13px] text-[#737373]">Rashid Pharmacy</p>
            </motion.div>
          </div>
        </motion.div>

        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.2 }} className="flex justify-center mb-6">
          <button data-testid="confirm-profile-button" onClick={onNext}
            className="flex items-center gap-2 px-8 py-3 rounded-xl bg-teal-600 text-white font-body font-bold text-sm shadow-lg shadow-teal-600/25 cursor-pointer">
            Confirm <Check size={16} />
          </button>
        </motion.div>
      </motion.div>
    </div>
  );
}
